<template>
  <div class="slide jackpot-slide local active">
    <p>
      {{this.$t('vdog_hit_total_ods')}}
      <span>{{totalOdds}}</span>
      {{this.$t('vdog_or_more_and_get')}}
    </p>
    <div class="a-vg-c--jackpot">
      <img src="https://cloud.aleacontrol.com/media/vDogs/local-jackpot.svg" alt />
      <div class="a-vg-c--jackpot__body">
        <span>{{this.$t('vdog_local_jackpot')}}</span>
        <p>
          <span class="amount">{{format(amount)}} </span>
          <span class="currency">{{currency.toUpperCase()}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    totalOdds: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    }
  }
}

</script>
